import PropTypes from 'prop-types'
import styled from 'styled-components'
import { BlocketSymbol } from '@blocket/blocket-ui'

const ExternalIcon = styled.img`
  height: ${({ height }) => `${height}px`};
  width: ${({ width }) => `${width}px`};
`

const validImage = (url) => {
  if (!url) {
    return false
  }

  let isValid
  const img = new Image()
  img.src = url

  if (img.complete) {
    isValid = true
  }

  img.onload = () => {
    isValid = true
  }

  img.onerror = () => {
    isValid = false
  }

  return isValid
}

const ExtensionIcon = ({ iconSrc = null, width = 20, height = 20 }) => {
  if (validImage(iconSrc)) {
    return <ExternalIcon src={iconSrc} width={width} height={height} alt="icon" />
  }

  return <BlocketSymbol width={width} height={height} />
}

ExtensionIcon.propTypes = {
  iconSrc: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default ExtensionIcon
